module.exports = __webpack_public_path__ + "img/vps.ab8f937.webp";